module.exports = __webpack_public_path__ + "static/media/plan-mas-250gb.e19dfc50.svg";